module.exports = __webpack_public_path__ + "img/playground.20b83308.jpg";